import React, { use, useEffect, useState } from "react";
import { TextInput, Textarea } from "@mantine/core";
import * as slideUpFormStyles from "./slideUpForm.module.scss";
import ButtonComponent from "../Home/ButtonComponent/ButtonComponent";
import { ndeFormInstance } from "../../lib/axios-client";
import { toast } from "react-toastify";
import { navigate } from "gatsby";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import { usePostHog } from 'posthog-js/react';

export default function SlideUpForm() {
  const posthog = usePostHog();
  const items = [
    { id: 1, label: "Website Design", text: "Website Design", checked: false },
    { id: 2, label: "Web App", text: "Web App", checked: false },
    { id: 3, label: "Mobile App", text: "Mobile App", checked: false },
    { id: 4, label: "Branding", text: "Branding", checked: false },
  ];

  const [apiLoading, setApiLoading] = useState(false);
  const [getCheckedValue, setCheckedValue] = useState(items);

  const schema = yup.object({
    name: yup
      .string()
      .required("Name is required!")
      .transform((value) => value.trim())
      .min(3, 'Name must contain at least 3 letters!'),
    phone: yup
      .string()
      .transform((value) => value.trim())
      .matches(/^(\+\d{1,4}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, {
        message: "Please enter a valid phone number",
        excludeEmptyString: true,
      }),
    email: yup
      .string()
      .required("Email is required!")
      .transform((value) => value.trim())
      .email("Please enter a valid email!"),
    service_items: yup
      .array()
      .test("at-least-one-checked", "Please select at least one checkbox!", (items) => items?.some((item) => item.checked)),
    message: yup
      .string()
      .required("Project Requirement is required!")
      .max(250, 'Project Requirement must be 250 characters or less')
      .transform((value) => value.trim())
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    trigger,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    reValidateMode: "onChange",
    defaultValues: {
      name: "",
      phone: "",
      email: "",
      service_items: items,
      message: "",
    },
  });

  const handleCheckboxChange = async (index, checked) => {
    const updatedItems = getCheckedValue;
    updatedItems[index].checked = checked;
    setValue("service_items", updatedItems);
    setCheckedValue(updatedItems);
    await trigger("service_items");
  };

  const handleCheckBoxOuterCardClick = async (index) => {
    const updatedItems = getCheckedValue;
    updatedItems[index].checked = !updatedItems[index].checked;
    setValue("service_items", updatedItems);
    setCheckedValue(updatedItems);
    await trigger("service_items");
  };

  const getCheckedServices = (items) => {
    return items
      .filter((item) => item.checked === true)
      .map((item) => item.label);
  };


  async function onFormSubmit(data) {
    setApiLoading(true);
    
    try {
      const landing_page = sessionStorage.getItem('landing_page');
      const formData = {
        ...data,
        service_items: getCheckedServices(data.service_items),
        landing_page: landing_page,
      }
      await ndeFormInstance.post('/itobuz-and-design-studio-contact-form', formData);
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "quote-form-submitted",
          ...data,
        });
      }
      posthog.capture('form_submitted', {
          form_id: 'contact_form_submitted',
          submission_status: 'success',
      });
      navigate("/thank-you");
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    } finally {
      setApiLoading(false);
    }
  }
  useEffect(() => {
    setCheckedValue(items);
  }, []);

  return (
    <div className={slideUpFormStyles.slideUpForm}>
      <div className={slideUpFormStyles.slideUpForm__container}>
        <div className={slideUpFormStyles.slideUpForm__formCard}>
          <p className={slideUpFormStyles.slideUpForm__formSubtitle}>ASK FOR A QUOTE</p>
          <h3 className={slideUpFormStyles.slideUpForm__formTitle}>What do you need?</h3>
          <form onSubmit={handleSubmit(onFormSubmit)}>
            <h4 className={slideUpFormStyles.slideUpForm__formLabel}>Services*</h4>

            <div className={slideUpFormStyles.slideUpForm__formCategory}>
              {getCheckedValue.map((item, index) => (
                <div
                  className={slideUpFormStyles.slideUpForm__categoryCard}
                  key={item.id}
                  onClick={() => handleCheckBoxOuterCardClick(index)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleCheckBoxOuterCardClick(index);
                    }
                  }}
                  role="button"
                  tabIndex="0"
                >
                  <input
                    checked={item.checked}
                    onChange={(event) => handleCheckboxChange(index, event.currentTarget.checked)}
                    type="checkbox"
                    id={item.id}
                    className={slideUpFormStyles.slideUpForm__checkBox}
                  />
                  <span className={slideUpFormStyles.slideUpForm__content}>{item.text}</span>
                </div>
              ))}
            </div>
            {(errors.service_items && errors.service_items.message) && (
              <div className="mt-5">
                <ErrorMessage message={errors.service_items.message} />
              </div>
            )}

            <div className={slideUpFormStyles.slideUpForm__formContainer}>
              <h4 className={slideUpFormStyles.slideUpForm__title}>More about you</h4>
              <div className={slideUpFormStyles.slideUpForm__nameEmail}>
                <div className={slideUpFormStyles.slideUpForm__customFormInput}>
                  <TextInput
                    placeholder="What is your name?*"
                    {...register("name")}
                    className={`${slideUpFormStyles.slideUpForm__name} ${errors.name && slideUpFormStyles.slideUpForm__errorInput}`}
                    size="lg"
                  />
                  {(errors.name && errors.name.message) && (<ErrorMessage message={errors.name.message} />)}
                </div>

                <div className={slideUpFormStyles.slideUpForm__customFormInput}>
                  <TextInput
                    placeholder="Your email for contact*"
                    {...register("email")}
                    className={`${slideUpFormStyles.slideUpForm__email} ${errors.email && slideUpFormStyles.slideUpForm__errorInput}`}
                    size="lg"
                  />
                  {(errors.email && errors.email.message) && (<ErrorMessage message={errors.email.message} />)}
                </div>

                <div className={slideUpFormStyles.slideUpForm__customFormInput}>
                  <TextInput
                    type='tel'
                    placeholder="Phone Number"
                    {...register("phone")}
                    className={slideUpFormStyles.slideUpForm__phoneNumber}
                    size="lg"
                  />
                  {(errors.phone && errors.phone.message) && (<ErrorMessage message={errors.phone.message} />)}
                </div>
              </div>

              <Textarea
                placeholder="Project Requirements*"
                {...register("message")}
                className={`${slideUpFormStyles.slideUpForm__comment} ${errors.comment && slideUpFormStyles.slideUpForm__errorInput}`}
                size="lg"
              />
              {(errors.message && errors.message.message) && (<ErrorMessage message={errors.message.message} />)} 

              <div className={slideUpFormStyles.slideUpForm__submitButton}>
                <ButtonComponent
                  buttonText={"Send Email"}
                  buttonStyle={"solidBg"}
                  type={"submit"}
                  className={slideUpFormStyles.slideUpForm__Button}
                  disabled={apiLoading}
                  loading={apiLoading}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
